import { render, staticRenderFns } from "./TheBudgetTableWrapper.vue?vue&type=template&id=578727a1"
import script from "./TheBudgetTableWrapper.vue?vue&type=script&lang=js"
export * from "./TheBudgetTableWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports